import { defineNuxtPlugin } from '#app/nuxt'
import { LazyIconAlert, LazyIconArrowAttribute, LazyIconArrowDropdown, LazyIconArrowForward, LazyIconArrowLeft, LazyIconArrowRight, LazyIconArrowU, LazyIconArrowUp2, LazyIconArrowUpBold, LazyIconArrowUp, LazyIconBadge, LazyIconBed, LazyIconBorderedArrow, LazyIconC, LazyIconCalendar, LazyIconCalendar2, LazyIconCall, LazyIconCallQuestion, LazyIconCar, LazyIconCart, LazyIconCatalogPin, LazyIconChat, LazyIconCheckMini, LazyIconCheck, LazyIconCheckBorder, LazyIconChevronBlack, LazyIconChevronDown, LazyIconChevronMini, LazyIconChevron, LazyIconCircle, LazyIconCityPinColored, LazyIconCityPin, LazyIconClose2, LazyIconCloseBold, LazyIconClose, LazyIconContact, LazyIconCruise, LazyIconCustomerSupport, LazyIconDateRange, LazyIconDesert, LazyIconDollarSignCircle, LazyIconDollar, LazyIconDoubleQuotation, LazyIconDropOff, LazyIconDuration, LazyIconEmailClosed, LazyIconEmail, LazyIconEmptyCart, LazyIconEyeHide, LazyIconEyeShow, LazyIconFacebook, LazyIconFaqArrow, LazyIconFilterList, LazyIconFilter, LazyIconGallery, LazyIconGetyourguide, LazyIconGoogle, LazyIconGuarantee, LazyIconGuide, LazyIconHamburger, LazyIconHelpCenter, LazyIconHotel, LazyIconHouse, LazyIconHouses, LazyIconInstagram, LazyIconInvoice, LazyIconJetski, LazyIconLandscape, LazyIconLinkedin, LazyIconLiveChat, LazyIconLocationHero, LazyIconLocationUnderline, LazyIconLocation, LazyIconLocationOutline, LazyIconLock, LazyIconMail, LazyIconMap, LazyIconMarker, LazyIconMinus, LazyIconMosque, LazyIconNoData, LazyIconOotlah, LazyIconOperation, LazyIconOrder, LazyIconPackages, LazyIconPassengers, LazyIconPersonOutline, LazyIconPerson, LazyIconPhoneInCall, LazyIconPickup, LazyIconPlay, LazyIconPlusCircle, LazyIconPlus, LazyIconPolicy, LazyIconPyramids, LazyIconQuote, LazyIconRestart, LazyIconReview, LazyIconRing, LazyIconSearchBold, LazyIconSearchIcon, LazyIconSearch, LazyIconShare, LazyIconShiny, LazyIconSightseeing, LazyIconSnapchat, LazyIconStar1, LazyIconStar, LazyIconSuccess, LazyIconSupportMail, LazyIconSupportWhatsapp, LazyIconSwap, LazyIconTicket, LazyIconTiktok, LazyIconTimer, LazyIconTourguide, LazyIconTripadvisorLogo, LazyIconTripadvisor, LazyIconTwitter, LazyIconUser, LazyIconViator, LazyIconVisas, LazyIconVoucher, LazyIconWarning, LazyIconWhatsappFill, LazyIconWhatsapp, LazyIconWordVector, LazyIconWorld, LazyIconX, LazyIconYacht, LazyIconYoutube } from '#components'
const lazyGlobalComponents = [
  ["IconAlert", LazyIconAlert],
["IconArrowAttribute", LazyIconArrowAttribute],
["IconArrowDropdown", LazyIconArrowDropdown],
["IconArrowForward", LazyIconArrowForward],
["IconArrowLeft", LazyIconArrowLeft],
["IconArrowRight", LazyIconArrowRight],
["IconArrowU", LazyIconArrowU],
["IconArrowUp2", LazyIconArrowUp2],
["IconArrowUpBold", LazyIconArrowUpBold],
["IconArrowUp", LazyIconArrowUp],
["IconBadge", LazyIconBadge],
["IconBed", LazyIconBed],
["IconBorderedArrow", LazyIconBorderedArrow],
["IconC", LazyIconC],
["IconCalendar", LazyIconCalendar],
["IconCalendar2", LazyIconCalendar2],
["IconCall", LazyIconCall],
["IconCallQuestion", LazyIconCallQuestion],
["IconCar", LazyIconCar],
["IconCart", LazyIconCart],
["IconCatalogPin", LazyIconCatalogPin],
["IconChat", LazyIconChat],
["IconCheckMini", LazyIconCheckMini],
["IconCheck", LazyIconCheck],
["IconCheckBorder", LazyIconCheckBorder],
["IconChevronBlack", LazyIconChevronBlack],
["IconChevronDown", LazyIconChevronDown],
["IconChevronMini", LazyIconChevronMini],
["IconChevron", LazyIconChevron],
["IconCircle", LazyIconCircle],
["IconCityPinColored", LazyIconCityPinColored],
["IconCityPin", LazyIconCityPin],
["IconClose2", LazyIconClose2],
["IconCloseBold", LazyIconCloseBold],
["IconClose", LazyIconClose],
["IconContact", LazyIconContact],
["IconCruise", LazyIconCruise],
["IconCustomerSupport", LazyIconCustomerSupport],
["IconDateRange", LazyIconDateRange],
["IconDesert", LazyIconDesert],
["IconDollarSignCircle", LazyIconDollarSignCircle],
["IconDollar", LazyIconDollar],
["IconDoubleQuotation", LazyIconDoubleQuotation],
["IconDropOff", LazyIconDropOff],
["IconDuration", LazyIconDuration],
["IconEmailClosed", LazyIconEmailClosed],
["IconEmail", LazyIconEmail],
["IconEmptyCart", LazyIconEmptyCart],
["IconEyeHide", LazyIconEyeHide],
["IconEyeShow", LazyIconEyeShow],
["IconFacebook", LazyIconFacebook],
["IconFaqArrow", LazyIconFaqArrow],
["IconFilterList", LazyIconFilterList],
["IconFilter", LazyIconFilter],
["IconGallery", LazyIconGallery],
["IconGetyourguide", LazyIconGetyourguide],
["IconGoogle", LazyIconGoogle],
["IconGuarantee", LazyIconGuarantee],
["IconGuide", LazyIconGuide],
["IconHamburger", LazyIconHamburger],
["IconHelpCenter", LazyIconHelpCenter],
["IconHotel", LazyIconHotel],
["IconHouse", LazyIconHouse],
["IconHouses", LazyIconHouses],
["IconInstagram", LazyIconInstagram],
["IconInvoice", LazyIconInvoice],
["IconJetski", LazyIconJetski],
["IconLandscape", LazyIconLandscape],
["IconLinkedin", LazyIconLinkedin],
["IconLiveChat", LazyIconLiveChat],
["IconLocationHero", LazyIconLocationHero],
["IconLocationUnderline", LazyIconLocationUnderline],
["IconLocation", LazyIconLocation],
["IconLocationOutline", LazyIconLocationOutline],
["IconLock", LazyIconLock],
["IconMail", LazyIconMail],
["IconMap", LazyIconMap],
["IconMarker", LazyIconMarker],
["IconMinus", LazyIconMinus],
["IconMosque", LazyIconMosque],
["IconNoData", LazyIconNoData],
["IconOotlah", LazyIconOotlah],
["IconOperation", LazyIconOperation],
["IconOrder", LazyIconOrder],
["IconPackages", LazyIconPackages],
["IconPassengers", LazyIconPassengers],
["IconPersonOutline", LazyIconPersonOutline],
["IconPerson", LazyIconPerson],
["IconPhoneInCall", LazyIconPhoneInCall],
["IconPickup", LazyIconPickup],
["IconPlay", LazyIconPlay],
["IconPlusCircle", LazyIconPlusCircle],
["IconPlus", LazyIconPlus],
["IconPolicy", LazyIconPolicy],
["IconPyramids", LazyIconPyramids],
["IconQuote", LazyIconQuote],
["IconRestart", LazyIconRestart],
["IconReview", LazyIconReview],
["IconRing", LazyIconRing],
["IconSearchBold", LazyIconSearchBold],
["IconSearchIcon", LazyIconSearchIcon],
["IconSearch", LazyIconSearch],
["IconShare", LazyIconShare],
["IconShiny", LazyIconShiny],
["IconSightseeing", LazyIconSightseeing],
["IconSnapchat", LazyIconSnapchat],
["IconStar1", LazyIconStar1],
["IconStar", LazyIconStar],
["IconSuccess", LazyIconSuccess],
["IconSupportMail", LazyIconSupportMail],
["IconSupportWhatsapp", LazyIconSupportWhatsapp],
["IconSwap", LazyIconSwap],
["IconTicket", LazyIconTicket],
["IconTiktok", LazyIconTiktok],
["IconTimer", LazyIconTimer],
["IconTourguide", LazyIconTourguide],
["IconTripadvisorLogo", LazyIconTripadvisorLogo],
["IconTripadvisor", LazyIconTripadvisor],
["IconTwitter", LazyIconTwitter],
["IconUser", LazyIconUser],
["IconViator", LazyIconViator],
["IconVisas", LazyIconVisas],
["IconVoucher", LazyIconVoucher],
["IconWarning", LazyIconWarning],
["IconWhatsappFill", LazyIconWhatsappFill],
["IconWhatsapp", LazyIconWhatsapp],
["IconWordVector", LazyIconWordVector],
["IconWorld", LazyIconWorld],
["IconX", LazyIconX],
["IconYacht", LazyIconYacht],
["IconYoutube", LazyIconYoutube],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
